<template>
    <ToolbarNode
        id="targetElement"
        class="toolbar-node"
        :note="note"
        :isNoteVisible="isNoteVisible"
        :status="toolbarStatus"
        @mouseenter="handleMouseEnterToolbarNode"
        @mouseleave="handleMouseLeave"
        @update:note="updateNote"
        @update:status="toolbarStatus = $event"
        @update:noteVisible="isNoteVisible = $event"
    ></ToolbarNode>
    <div
        class="flex gap-x-2 border-2 border-primary-color-500 rounded-full py-4.5 cursor-pointer justify-center items-center px-1 group h-16 w-72"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        @click="$emit('clickOnNode')"
    >
        <div class="bg-primary-color-100 p-1 rounded-lg">
            <ClockIcon class="w-6 h-6 text-primary-color-600"></ClockIcon>
        </div>
        <div class="text-sm leading-5 font-medium text-gray-500 max-w-[176px]">
            Delay until <b class="text-gray-900">{{ convertTriggerEvent(type) }}</b>
        </div>
        <div class="hidden group-hover:block bg-gray-100 rounded-full p-1" @click="$emit('removeNode')">
            <TrashIcon class="h-5 w-5"></TrashIcon>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue"
import { ClockIcon, TrashIcon } from "@heroicons/vue/outline"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import ToolbarNode from "@/components/workflows/ToolbarNode.vue"

interface Props {
    type?: string
    note?: { text?: string; lastEdited?: string }
}
const props = defineProps<Props>()

const emits = defineEmits(["update:note", "removeNode", "clickOnNode"])

const isNoteVisible = ref(false)
const toolbarStatus = ref("emptyClosed")
const localNote = ref(props.note)

let hideTimeout: ReturnType<typeof setTimeout>
function handleMouseEnter() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function handleMouseLeave(event: MouseEvent) {
    hideTimeout = setTimeout(() => {
        if (
            ((event.relatedTarget as Element) && (event.relatedTarget as Element).classList.contains("toolbar-node")) ||
            toolbarStatus.value !== "emptyClosed" ||
            localNote.value?.text?.length !== 0
        ) {
            return
        }
        isNoteVisible.value = false
    }, 300)
}

function handleMouseEnterToolbarNode() {
    clearTimeout(hideTimeout)
    isNoteVisible.value = true
}

function updateNote(note: { text?: string; lastEdited?: string }) {
    emits("update:note", note)
    localNote.value = note
}

onMounted(() => {
    if (localNote.value?.text?.length !== 0) {
        isNoteVisible.value = true
    }
})
</script>
